import { render } from "./KidneySpecificSectionEMROATS.vue?vue&type=template&id=11852d98&scoped=true"
import script from "./KidneySpecificSectionEMROATS.vue?vue&type=script&lang=js"
export * from "./KidneySpecificSectionEMROATS.vue?vue&type=script&lang=js"

import "./KidneySpecificSectionEMROATS.vue?vue&type=style&index=0&id=11852d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11852d98"],['__file',"src/components/KidneySpecificSectionEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11852d98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11852d98', __exports__)) {
    api.reload('11852d98', __exports__)
  }
  
  module.hot.accept("./KidneySpecificSectionEMROATS.vue?vue&type=template&id=11852d98&scoped=true", () => {
    api.rerender('11852d98', render)
  })

}


export default __exports__